const requireWidgets = import.meta.glob('./**/Widget.vue');
const widgets = Object.entries(requireWidgets).map(([key, value]) => ({
    key: key.replace('/Widget.vue', '').split('/').last(),
    value
}));

export {
    widgets
};
